@use "../../components/Button/NordicButton.module.scss";
@use "../../scss/colors";

.pageContent {
	background: colors.$white;
	max-width: 856px;
	border-radius: 35px;
	box-shadow: 0px 2px 4px 0px colors.$black_shadow_soft;
	margin: 2rem 2rem 0 2rem;
	padding: 2rem;
}

@media screen and (min-width: 992px) {
	.pageContent {
		display: grid;
		grid-template-columns: calc(100% - 400px - 2rem) 400px;
		gap: 2rem;
		margin: 2rem auto;
		gap: 4rem;
		padding: 4rem;
	}
}

.hubspotForm label {
	margin-top: 2rem;
}

.hubspotForm ul {
	list-style: none;
	padding: 0;
}
.hubspotForm ul label {
	margin-top: 0;
}

.hubspotForm :global(.hs-input) {
	width: 100% !important;
}

.hubspotForm input[type="submit"] {
	@extend .button;
	@extend .slant;
	@extend .success;
}

.hubspotForm :global(.hs-submit) {
	margin-top: 2rem;
	margin-right: 2rem;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
}

.hubspotForm :global(.hs-form-radio-display) span {
	margin-left: 1rem;
}

.hubspotForm ul.announcementListOverride {
	padding-left: 20px;
	list-style: disc;

	a {
		font-size: 15px;
	}
	a:link {
		color: colors.$nordic_lake;
	}
	a:visited {
		color: colors.$nordic_lake;
	}
	a:hover {
		color: colors.$nordic_blue;
	}
	a:active {
		color: colors.$nordic_blue;
	}
}

.pageContent h2 {
	font-weight: 500;
	font-size: 22px;
}

.announcementList {
	padding-left: 20px;
}

.announcementCheck {
	margin-bottom: 0;
}

.copyColumns {
	.copyRow {
		display: flex;
		flex-direction: row;
		justify-content: space-between;

		span:nth-of-type(even) {
			text-align: right;
		}
	}
}
